import React, { useState } from 'react'
import { Card, CardBody, Form, FormGroup, Label, Input, Button, Row, Col, Container } from 'reactstrap'
import Breadcrumb from 'Components/UI/Breadcrumb'

function SmsTemplate() {
  const [templateName, setTemplateName] = useState('')
  const [message, setMessage] = useState('')
  const [type, setType] = useState('booking')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // TODO: Handle form submission
    console.log({ templateName, message, type })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "SMS Template" }]} />
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">SMS Template</h4>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={12}>
                  <FormGroup className="mb-3">
                    <Label htmlFor="templateName">Template Name</Label>
                    <Input
                      id="templateName"
                      type="text"
                      value={templateName}
                      onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter template name"
                      required
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label htmlFor="type">Template Type</Label>
                    <Input
                      id="type"
                      type="select"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="booking">Booking</option>
                      <option value="reminder">Reminder</option>
                      <option value="confirmation">Confirmation</option>
                      <option value="cancellation">Cancellation</option>
                    </Input>
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label htmlFor="message">Message Content</Label>
                    <Input
                      id="message"
                      type="textarea"
                      rows={5}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Enter SMS message content"
                      required
                    />
                    <small className="text-muted">
                      Available variables: {'{customer_name}'}, {'{booking_id}'}, {'{booking_date}'}, {'{booking_time}'}
                    </small>
                  </FormGroup>

                  <div className="text-end mt-3">
                    <Button type="submit" color="primary">
                      Save Template
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default SmsTemplate
